import * as React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CardActionArea,
  CardActions,
  Container,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  logosHospitalarios,
  logosFarmaceutico,
  logosMedico,
} from "../data/dataProduct";
import "aos/dist/aos.css";

export default function MultiActionAreaCard({ type }) {
  const dataMap = {
    hospitalarios: logosHospitalarios,
    farmaceuticos: logosFarmaceutico,
    medicos: logosMedico,
  };

  const dataRender = dataMap[type] ?? [];

  const mensajeTopo =
    type === "hospitalarios"
      ? "Nuestros productos hospitalarios son elaborados bajo GMP (Buenas Prácticas de Fabricación y Control)."
      : type === "farmaceuticos"
      ? "Nuestros productos farmacéuticos son elaborados bajo GMP (Buenas Prácticas de Fabricación y Control)."
      : "Nuestros productos médicos son elaborados bajo GMP (Buenas Prácticas de Fabricación y Control).";

  if (!dataRender.length) return null;

  return (
    <Container maxWidth="lg" sx={{ my: 2, mb: 5 }}>
      <Grid
        container
        spacing={2}
        sx={{ justifyContent: "center", alignItems: "stretch" }}
      >
        <Grid item xs={12}>
          <Typography
            variant="body2"
            sx={{ textAlign: "center", fontWeight: 500, color: "#fff" }}
          >
            {mensajeTopo}
          </Typography>
        </Grid>

        {dataRender.map((item) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={item.id || item.name}
            sx={{ display: "flex" }}
          >
            <Card
              data-aos="fade-up"
              elevation={2}
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
                transition: "transform .12s ease, box-shadow .12s ease",
                "&:hover": { transform: "translateY(-2px)", boxShadow: 6 },
              }}
            >
              <CardActionArea
                component={Link}
                to={`/productos/${item.name.replaceAll(" ", "")}`}
                sx={{ display: "block" }}
              >
                {/* Contenedor 16:9 para imagen (logos): */}
                <Box sx={{ position: "relative", pt: "56.25%", borderBottom: "1px solid #e0e0e0" }}>
                  <Box
                    component="img"
                    src={item.img}
                    alt={`Logo de ${item.name}`}
                    loading="lazy"
                    sx={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "contain", // logos no se recortan
                      p: 2,
                    }}
                  />
                </Box>

                <CardContent sx={{ pt: 1, pb: 2 }}>
                  <Typography
                    gutterBottom
                    variant="h6"
                    component="h3"
                    sx={{
                      color: "#2A4E9C",
                      fontWeight: 700,
                      fontSize: "clamp(1rem, 1.2vw, 1.1rem)",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      minHeight: 28,
                    }}
                  >
                    {item.name}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      minHeight: 40,
                    }}
                  >
                    {item.description}
                  </Typography>

                  {item.description2 && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", mt: 0.5 }}
                    >
                      {item.description2}
                    </Typography>
                  )}
                </CardContent>
              </CardActionArea>

              <CardActions
                sx={{
                  mt: "auto",
                  bgcolor: "#2A4E9C",
                  transition: "background-color .15s ease",
                  "&:hover": { bgcolor: "#1d3a7a" },
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#fff",
                }}
              >
                <Link
                  to={`/productos/${item.name.replaceAll(" ", "")}`}
                  sx={{ color: "#ffff" }}
                  style={{ textDecoration: "none", color: "#ffff" }}  
                  aria-label={`Ver más sobre ${item.name}`}
                >
                  Ver más
                </Link>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
